const API_KEY= "AIzaSyD_vBerUi8Cgb1r6vxLwWs1PWJZj7AiW04";
const channelID=  "UC0eoImVpOfJ8_dsDdOdVwXg";

export {API_KEY,channelID}
